import { motion } from "framer-motion";

export const ease = [0.22, 0.7, 0.2, 1];

export const fadeUp = {
  hidden: { opacity: 0, y: 32 },
  show: (i = 0) => ({
    opacity: 1, y: 0,
    transition: { duration: 0.7, ease, delay: i * 0.08 },
  }),
};

export const stagger = {
  hidden: {},
  show: { transition: { staggerChildren: 0.09 } },
};

/** Scroll-reveal wrapper. */
export function Reveal({ children, className = "", delay = 0, y = 32, once = true, ...rest }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, margin: "-80px" }}
      transition={{ duration: 0.7, ease, delay }}
      {...rest}
    >
      {children}
    </motion.div>
  );
}

/** Masked line reveal — for hero headline. Splits by <br/> children via array of lines. */
export function LineReveal({ lines = [], className = "", startDelay = 0.15 }) {
  return (
    <span className={className} style={{ display: "block" }}>
      {lines.map((line, i) => (
        <span key={i} style={{ display: "block", overflow: "hidden" }}>
          <motion.span
            style={{ display: "block" }}
            initial={{ y: "110%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 0.9, ease, delay: startDelay + i * 0.12 }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
}

export { motion };
